import { render, staticRenderFns } from "./AppMenuPageTemplateModal.vue?vue&type=template&id=18d8e8b0"
import script from "./AppMenuPageTemplateModal.vue?vue&type=script&lang=js"
export * from "./AppMenuPageTemplateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports